<template>
  <div class="documents-table">
    <NrTableHeader
      class="documents-table-header"
      :columns="columns"
      :resultCount="searchResultsCount"
      :totalCount="allDocumentsCount"
      @handleSidebarToggle="toggleFilter"
    />
    <NrTable
      striped
      tableName="documents"
      class="documents-table"
      id="documents-table"
      :rows="documents"
      :columns="columns"
      :isLoading="isLoading"
      @sort="$emit('sort', $event)"
    >
      <template v-slot:title="{ column, dataKey, row, value }">
        <td :key="dataKey">
          <NrTooltip :label="value" v-if="value">
            <a :href="`/documents/${row.id}`">
              {{ truncate(value, { length: column.maxChar }) }}
            </a>
          </NrTooltip>
        </td>
      </template>

      <template v-slot:pretty_id="{ value, dataKey }">
        <td :key="dataKey">
          <NrTooltip :label="value" v-if="value">
            <a v-if="legacyRequestShowPage" :href="`/requests/${value}`">{{
              value
            }}</a>
            <router-link v-else :to="`/requests/${value}`">
              {{ value }}
            </router-link>
          </NrTooltip>
        </td>
      </template>

      <template v-slot:folder_name="{ value, column, dataKey }">
        <td :key="dataKey">
          <NrTooltip :label="value" v-if="value">
            {{ truncate(value, { length: column.maxChar }) }}
          </NrTooltip>
        </td>
      </template>

      <template v-slot:description="{ value, column, dataKey }">
        <td :key="dataKey">
          <NrTooltip :label="value" v-if="value">
            {{ truncate(value, { length: column.maxChar }) }}
          </NrTooltip>
        </td>
      </template>
    </NrTable>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NrTableHeader from '@nextrequestco/components/src/components/NrTableHeader'
import NrTable from '@nextrequestco/components/src/components/NrTable'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip'
import togglePageScroll from '../../../mixins/toggle-page-scroll.ts'
import isEmpty from 'lodash/isEmpty'
import truncate from 'lodash/truncate'

export default {
  mixins: [togglePageScroll],

  components: { NrTable, NrTooltip, NrTableHeader },

  props: {
    height: { type: Number, default: 300 }
  },

  computed: {
    ...mapState('documents', [
      'searchResultsCount',
      'allDocumentsCount',
      'columns',
      'documents',
      'isLoading'
    ]),
    ...mapState(['account', 'currentUser']),
    legacyRequestShowPage() {
      return (
        !isEmpty(this.currentUser) &&
        this.account.legacy_request_show_enabled &&
        !this.currentUser?.request_show_beta
      )
    },

    documentsTableHeight() {
      const loadedHeight = this.height + 'px'
      if (this.isSmallScreen()) return 'auto'
      return loadedHeight
    }
  },

  methods: {
    truncate,
    ...mapActions('documents', ['toggleFilter'])
  }
}
</script>

<style lang="scss">
#documents-table {
  height: v-bind(documentsTableHeight);
}
</style>
